import { csrfToken } from "@/lib/orderActions"
import { directUpload } from "@/lib/directUpload"

// Open House — the new flow's own draft answers (Customer::OpenHousePostings).
// Every other answer, the draft itself and submit keep using today's endpoints
// (lib/postProjectActions.js). Same transport rules: fetch XHR over the cookie
// session with the CSRF header, never an Inertia visit.

async function request(path, method, body) {
  const res = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": csrfToken() },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await res.json().catch(() => ({}))

  if (!res.ok) {
    const err = new Error(Array.isArray(data?.errors) && data.errors.length ? data.errors.join(" ") : "Request failed")
    err.status = res.status
    err.data = data
    throw err
  }

  return data.openHouse
}

// Marks a draft (made with today's POST /post/drafts) as Open House.
export function markOpenHouse(draftId) {
  return request(`/post/drafts/${draftId}/open_house`, "POST")
}

// Saves any of short_description, outline_text, supplies_outline,
// outline_file or remove_outline_file. A File in outline_file goes straight to
// storage first and is sent as its signed blob id.
export async function saveOpenHouse(draftId, answers) {
  const file = answers.outline_file
  const body = typeof File !== "undefined" && file instanceof File
    ? { ...answers, outline_file: await directUpload(file) }
    : answers

  return request(`/post/drafts/${draftId}/open_house`, "PATCH", { open_house: body })
}
